import React from "react";
import SearchResultContainer from "@apps/SearchResultContainer/SearchResultContainer";
import i18n from "@apps/Shared/translation/i18n";
import {I18nextProvider} from "react-i18next";

function App(): JSX.Element {
    return (
        <I18nextProvider i18n={i18n}>
            <SearchResultContainer/>
        </I18nextProvider>
    );
}

export default App;